import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { getStaticStore, getStaticStoreSuccess } from '../actions/static-store.action';
import { StaticStoreService } from '../../services/static-store.service';
import { StaticStoreSource } from '../../domain/models/static-store-source.model';

@Injectable()
export class StaticStoreEffects {

  public staticStore$: unknown;

  constructor(private actions$: Actions,
    private staticStoreService: StaticStoreService) {
    this.createEffects()
  }

  private createEffects() {
    this.staticStore$ = createEffect(() => this.actions$.pipe(
      ofType(getStaticStore),
      mergeMap(({ source }) =>
        this.staticStoreService.Get(source)
          .pipe(map(response => {
            return getStaticStoreSuccess({ response: new StaticStoreSource(source, response) });
          }),
            catchError(() => of())
          )
      )
    )
    );
  }
}
